import CardAboutModal from "./CardAboutModal";
import PlayBox from "./PlayBox";
import ThisIsModal from "./ThisIsModal";
import Thumbnail from "./Thumbnails";
import { Songcard } from "@/types";
import {
  Card,
  CardBody,
  Center,
  Divider,
  HStack,
  Stack,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import Link from "next/link";
import { useRef, useState } from "react";

export interface CollectorProps {
  name: string;
  id: number;
}
export default function ArtistCard({ card }: { card: Songcard }) {
  const { colorMode } = useColorMode();
  const [modelOpen, setModalOpen] = useState(false);
  const ref = useRef(null);
  // const isInView = useInView(ref, { once: true });

  return (
    <>
      <div key={card.id}>
        <Center
          ref={ref}
          // style={{
          //   transform: isInView ? "none" : "translateY(+100px)",
          //   transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          // }}
        >
          <Card
            maxW="xs"
            align="center"
            bgColor={colorMode == "dark" ? "black" : "white"}
            variant="outline"
            borderColor={colorMode == "dark" ? "white" : "black"}
            borderStyle="dotted"
            borderRadius={15}
            shadow={"md"}
          >
            <CardBody>
              <div onClick={() => setModalOpen(true)}>
                <Thumbnail
                  ext_file={card.ext_file}
                  comp_file={card.comp_file}
                  image={card.image}
                />
              </div>
              <Stack mt="6" mb="0" spacing="3">
                <Center>
                  <PlayBox card={card} />
                </Center>
                <Text ml={4} mb={1} mt={2}>
                  is a Songcard from
                  <br />
                  {card.primary_artist && (
                    <Text as="b" key={card.primary_artist.slug}>
                      <Link href={`/artists/${card.primary_artist.slug}`}>
                        {card.primary_artist.name}
                      </Link>
                    </Text>
                  )}
                </Text>
                <Divider mt={0} mb={2} />
                <Center>
                  <HStack justify="space-between" w="94%">
                    <CardAboutModal card={card} price={false} showOpen={true} />
                    <ThisIsModal
                      card={card}
                      price={false}
                      showOpen={modelOpen}
                      setModalOpen={setModalOpen}
                    />
                  </HStack>
                </Center>
              </Stack>
            </CardBody>
          </Card>
        </Center>
        <br />
      </div>
    </>
  );
}
